module.exports = __webpack_public_path__ + "img/new2.667c8c02.svg";